<template lang="pug">
w-text.f-text(
  :class=`{ classes }`
  v-bind=`{ value, label, required, validate }`
  ref='input'
  @input='input'
  @change='change'
)
</template>

<script lang="js">
import WText, { mixin } from '@/widgets/w-text'
import { Logger } from '@/lib/logger'

export default {
  name: 'TextField',
  mixins: [ mixin ],
  components: { WText },
  props: {
    label: {
      type: String,
      default: 'text'
    },
    required: {
      type: Boolean,
      default: false
    },
    filter: Object,
    validate: {
      type: [ Object, Array, Function ],
      default: () => function ( value ) {
        // Logger.debug( 'validate text', '<f-text>', {
        //   value,
        //   valid: isText( value )
        // })()
        // if ( !isText( value )) {
        //   return 'valid text required'
        // }
      }
      // TODO: add text validation regardless
    },
    fullWidth: Boolean
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {
    classes() {
      return {
        'full-width': this.fullWidth
      }
}
  }
}
</script>

<style lang="scss">
.f-text {
  display: relative;
  &.full-width {
    width: 100%;
    .w-text {
      width: 100%;
    }
  }
}
</style>
